import { createTRPCContext } from '@trpc/tanstack-react-query';
import type { AppRouter } from '@servwell/api/router';

/**
 * The recommended v11 client integration. `useTRPC()` returns a typed proxy; feed its
 * `.queryOptions()` / `.mutationOptions()` into TanStack Query's useQuery/useMutation.
 */
export const { TRPCProvider, useTRPC, useTRPCClient } = createTRPCContext<AppRouter>();
